const language = {
    'pt': {
        add_assist: 'Adicionar Assistência',
        add_new: 'Adicionar Projeto',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        adicionar_projeto: 'Projetos de Software',
        ano: 'Ano',
        area_placeholder: 'Selecione a sua area',
        assistencia: 'Assistência de Software',
        assistencia_botao: 'Adicionar pedido de assistência',
        assistencia_permitida: 'Assistência Permitida',
        assistencia_projeto: 'Adicionar Projetos',
        assistencia_remota: 'Assistência Remota',
        birthday: 'Data de nascimento',
        cancel: 'Cancelar', back: 'Voltar',
        check_back_later: 'Por favor, verifique novamente mais tarde para atualizações ou entre em contato com a equipa responsável.',
        city: 'Cidade',
        city_placeholder: 'Introduza a cidade',
        close: 'Fechar',
        codProjeto: 'Código do Projeto',
        codProjeto_placeholder: 'Introduza o Código do Projeto',
        company_news: 'Notícias da Empresa',
        completed: 'Concluído',
        completed_tasks: 'Tarefas Concluídas',
        config: 'Configuração',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        country: 'País',
        country_placeholder: 'Introduza o país',
        dark_mode: 'Dark mode',
        data: 'Data de Publicação',
        data_creacao: 'Data de Criação',
        data_disponivel: 'Disponível até',
        dates: 'Datas',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        date_update: 'Data de Alteração',
        deadlines: 'Prazos',
        deadline: 'Prazo',
        delayed: 'Atrasado',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departamento: 'Departamentos',
        departamento_data: 'Dados departamentais',
        departamento_placeholder: 'Dados de Departamento',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        due_data: 'Data Limite',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        empty: 'Veio vazio',
        empresa: 'Empresa',
        empresas: 'Empresas',
        empresa_placeholder: 'Introduza a Empresa',
        entity: 'Projetos de Software',
        entity_edit: 'Editar Projeto',
        entity_list: 'Listagem de Projetos',
        entity_new: 'Novo Projeto',
        entity_type: 'Tipo de entidade',
        filter_concluido: 'Concluídos',
        filter_placeholder: 'Procurar',
        filter_resolver: 'Pedidos',
        hours: 'horas',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        language: 'Lingua',
        licenca: 'Licença',
        licenca_placeholder: 'Introduza o Número da Licença',
        local: 'Localidade',
        local_data: 'Dados geográficos',
        local_placeholder: 'Introduza a localidade',
        login_data: 'Dados de login',
        main_panel: 'Painel Principal',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        no_assist: 'Ainda não tem tempo de assistência definida.',
        no_tasks_scheduled: 'Não há tarefas programadas para esta semana no momento.',
        observacao: 'Observação',
        observacao_placeholder: 'Escreva algo',
        on_time: 'No Prazo',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Confirmação da Password',
        password_confirmation_placeholder: 'Confirme a password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        personal_data: 'Dados pessoais',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        principal: 'Principal',
        profile: 'Perfil',
        projetos: 'Projetos',
        numero_l: 'Número de Licença',
        remove: 'Remover',
        resume: 'Resumo Anual de Assistência',
        save: 'Salvar',
        software: 'Software',
        software_line: 'Linha de Software',
        software_line_placeholder: 'Introduza o Linha de Software',
        software_type: 'Tipo de Software',
        software_type_placeholder: 'Introduza o Tipo de Software',
        start_data: 'Data de Início',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        task_dashboard: 'Dashboard: Análise das Tarefas',
        task_priority: 'Prioridade das Tarefas',
        task_status: 'Estado das tarefas',
        termino: 'Data de Termino',
        termino_stats: 'Estatísticas de Termino',
        text: 'Texto',
        time: 'Tempo de Assistência',
        time_hours: 'Tempo Total (Horas)',
        time_minutes: 'Tempo Total (Minutos)',
        time_placeholder: 'Introduza o Tempo de Assistência',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        to_start: 'A Iniciar',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        type_error: 'Tipo ou Linha não encontrados',
        under_review: 'Em Verificação',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        validade_identificacao: 'Validade da identificacao',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!'
    },

    'en': {
        add_assist: 'Add Assistance',
        add_new: 'Add Project',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsibles',
        adicionar_projeto: 'Software Projects',
        ano: 'Year',
        area_placeholder: 'Select your area',
        assistencia: 'Software Assistance',
        assistencia_botao: 'Add assistance request',
        assistencia_permitida: 'Allowed Assistance',
        assistencia_projeto: 'Add Projects',
        assistencia_remota: 'Remote Assistance',
        birthday: 'Date of Birth',
        cancel: 'Cancel',
        check_back_later: 'Please check back later for updates or contact the responsible team.',
        city: 'City',
        city_placeholder: 'Enter the city',
        close: 'Close',
        codProjeto: 'Project Code',
        codProjeto_placeholder: 'Enter the Project Code',
        company_news: 'Company News',
        completed: 'Completed',
        completed_tasks: 'Completed Tasks',
        config: 'Configuration',
        content: 'Content',
        content_edit: 'Edit Content',
        content_list: 'Content List',
        content_new: 'New Content',
        country: 'Country',
        country_placeholder: 'Enter the country',
        dark_mode: 'Dark Mode',
        data: 'Publication Date',
        data_creacao: 'Creation Date',
        data_disponivel: 'Available until',
        dates: 'Dates',
        date_creation: 'Creation',
        date_last_update: 'Last Update',
        date_publication: 'Publication',
        date_update: 'Modification Date',
        deadlines: 'Deadlines',
        deadline: 'Deadline',
        delayed: 'Delayed',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Problem deleting record!',
        delete_success: 'Record successfully deleted!',
        delete_text: 'Are you sure you want to proceed?',
        delete_title: 'Delete Record',
        departamento: 'Departments',
        departamento_data: 'Departmental Data',
        departamento_placeholder: 'Department Data',
        description: 'Description',
        description_placeholder: 'Enter a description',
        district: 'District',
        district_placeholder: 'Enter the district',
        due_data: 'Due Date',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Problem updating record!',
        edit_success: 'Record successfully updated!',
        edit_text: 'Are you sure you want to proceed?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        empty: 'Came empty',
        empresa: 'Company',
        empresas: 'Companies',
        empresa_placeholder: 'Enter the Company',
        entity: 'Software Projects',
        entity_edit: 'Edit Project',
        entity_list: 'Project List',
        entity_new: 'New Project',
        entity_type: 'Entity Type',
        filter_concluido: 'Completed',
        filter_placeholder: 'Search',
        filter_resolver: 'Requests',
        hours: 'hours',
        id: 'ID',
        identification_number: 'Identification Number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validation',
        image: 'Image',
        image_choose: 'Choose Image',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Problem inserting record!',
        insert_success: 'Record successfully inserted!',
        insert_text: 'Are you sure you want to proceed?',
        insert_title: 'New Record',
        language: 'Language',
        licenca: 'License',
        licenca_placeholder: 'Enter the License Number',
        local: 'Locality',
        local_data: 'Geographical Data',
        local_placeholder: 'Enter the locality',
        login_data: 'Login Data',
        main_panel: 'Main Panel',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        no_assist: 'You do not have any assistance time set yet.',
        no_tasks_scheduled: 'No tasks scheduled for this week at the moment.',
        observacao: 'Observation',
        observacao_placeholder: 'Write something',
        on_time: 'On Time',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Password Confirmation',
        password_confirmation_placeholder: 'Confirm the password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Element successfully inserted!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        personal_data: 'Personal Data',
        postal_code: 'Postal Code',
        postal_code_placeholder: 'Enter the postal code',
        principal: 'Principal',
        profile: 'Profile',
        projetos: 'Projects',
        numero_l: 'License Number',
        remove: 'Remove',
        resume: 'Annual Assistance Summary',
        save: 'Save',
        software: 'Software',
        software_line: 'Software Line',
        software_line_placeholder: 'Enter the Software Line',
        software_type: 'Software Type',
        software_type_placeholder: 'Enter the Software Type',
        start_data: 'Start Date',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        task_dashboard: 'Dashboard: Task Analysis',
        task_priority: 'Task Priority',
        task_status: 'Task Status',
        termino: 'End Date',
        termino_stats: 'End Date Statistics',
        text: 'Text',
        time: 'Assistance Time',
        time_hours: 'Total Time (Hours)',
        time_minutes: 'Total Time (Minutes)',
        time_placeholder: 'Enter the Assistance Time',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        title: 'Title',
        title_placeholder: 'Enter the title',
        to_start: 'To Start',
        type: 'Client Type',
        type_identification: 'Identification Type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the client type',
        type_error: 'Type or Line not Found',
        under_review: 'Under Review',
        username: 'Username',
        username_placeholder: 'Enter the username',
        validade_identificacao: 'Identification Validity',
        vat: 'Tax ID',
        vat_placeholder: 'Enter the Tax ID',
        village: 'Parish',
        village_placeholder: 'Enter the parish',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Problem inserting record!',
        warning_success: 'Record successfully inserted!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!'
    },

    'es': {

    }
}

module.exports = {
    language
};